import { Backdrop, styled } from "@mui/material";

export const MyPopup = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.modal,
}));
